export default __webpack_public_path__ + "static/media/warrantech-logo.67ed7644.png";